import { render, staticRenderFns } from "./bogpayresult.vue?vue&type=template&id=779720b3"
import script from "./bogpayresult.vue?vue&type=script&lang=js"
export * from "./bogpayresult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports